import CompaignEmpty from './CompaignEmpty';

export default CompaignEmpty;
